<template>
  <v-text-field
    solo
    dark
    v-mask="'##'"
    class="input-center input-qty"
    append-outer-icon="mdi-plus"
    prepend-icon="mdi-minus"
    @click:append-outer.stop="increase"
    @click:prepend.stop="decrease"
    @change="$emit('input', $event)"
    :value="parseInt(value)"
    hide-details
    :class="classExtend"
    :background-color="bgcolor"
    :dark="dark"
    :disabled="disabled"
  />
</template>
<script>
export default {
  data(){
      return{
          step:1,
          max:100,
          min:1
      }
  },
  // minValue: optional lower bound (default 1), e.g. 0 where an amount may be empty.
  props:['value', 'classExtend','bgcolor', 'dark', 'disabled', 'minValue'],
  computed: {
    lowest() {
      return this.minValue === undefined ? this.min : parseInt(this.minValue);
    }
  },
  methods: {
    increase() {
      if (this.disabled) return;
      if (isNaN(parseInt(this.value))) return this.$emit("input", this.step);
      if (this.value === this.max) return;

      this.$emit("input", parseInt(this.value) + this.step);
    },

    decrease() {
      if (this.disabled) return;
      if (isNaN(parseInt(this.value))) return this.$emit("input", this.lowest);
      if (parseInt(this.value) <= this.lowest) return;
      this.$emit("input", parseInt(this.value) - this.step);
    }
  }
};
</script>
<style>
  .v-text-field.v-text-field--solo.min-height .v-input__control{
    min-height: 28px;
  }
  .v-text-field.v-text-field--solo.min-height .v-input__prepend-outer, .v-text-field.v-text-field--solo.min-height .v-input__append-outer{
    margin-top: 5px;
  }
  
</style>
